import React from 'react'
import PropTypes from 'prop-types'
import classnames from "classnames"
import {useFormContext} from "react-hook-form"
//************************************//
import InputContainer from "@src/components/helpers/InputContainer"
import CustomFormGroup from "@src/components/helpers/CustomFormGroup"
import {trans} from "@utils"
//************************************//

const CommonInputs = props => {
  const {data} = props
  const formMethods = useFormContext()
  const {control, register, errors, setValue, unregister} = formMethods
  //************************************//
  return (
    <>
      <CustomFormGroup title={trans('gen.name')}>
        <InputContainer
          autoFocus
          control={control}
          type={'text'}
          name={"name"}
          className={classnames({
            'is-invalid': _.get(errors, 'name')
          })}
          defaultValue={data.name ?? ''}
          rules={{
            required: trans('user.validation.required')
          }}
        />
      </CustomFormGroup>
      <CustomFormGroup title={trans('gen.description')}>
        <InputContainer
          name={`description`}
          type={'contentEditable'}
          onBlur={() => {}}
          innerRef={register}
          formMethods={formMethods}
          textAreaProps={{ maxLength: 2000 }}
          style={{ borderColor: "#d8d6de", borderRadius: 5 }}
          className={classnames({
            "invalid-value": _.get(errors, `description`)
          })}
          placeholder={"."}
          defaultValue={_.get(data, `description`, '') ?? ""}
        />
      </CustomFormGroup>
      <CustomFormGroup title={trans('customFields.isRequired')}>
        <InputContainer
          id={`${data.key}-is_required`}
          type={'checkbox'}
          name={"is_required"}
          // value={"sss"}
          defaultChecked={data.is_required}
          innerRef={register()}
        />
      </CustomFormGroup>
    </>
  )
}

CommonInputs.propTypes = {

}

export default CommonInputs
